import React from 'react';

function PriceHistoryChart({ history }) {
  // Prepare data for chart
  if (!history || history.length === 0) return <div>No hay historial de precios.</div>;

  // Group by store
  const stores = {};
  history.forEach(row => {
    if (!stores[row.store_name]) stores[row.store_name] = [];
    stores[row.store_name].push(row);
  });

  // Get all dates (sorted)
  const allDates = Array.from(new Set(history.map(h => h.checked_at))).sort();


  // Simple SVG line chart (responsive)
  // Find min/max for scaling
  const allPrices = history.map(h => h.store_price).filter(Boolean);
  const minPrice = Math.min(...allPrices);
  const maxPrice = Math.max(...allPrices);
  const height = 220;
  const width = 600;
  const padding = 40;
  const colors = ['#1976d2', '#43a047', '#fbc02d', '#e53935', '#8e24aa', '#00838f', '#c2185b'];
  const storeNames = Object.keys(stores);

  function getX(idx) {
    return padding + (width - 2 * padding) * (idx / (allDates.length - 1));
  }
  function getY(price) {
    if (maxPrice === minPrice) return height / 2;
    return height - padding - ((price - minPrice) / (maxPrice - minPrice)) * (height - 2 * padding);
  }

  return (
    <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #eee', padding: 16, marginBottom: 24 }}>
      <h3 style={{ margin: '8px 0 16px 0' }}>Historial de Precios</h3>
      <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} style={{ maxWidth: 700 }}>
        {/* Axes */}
        <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="#bbb" />
        <line x1={padding} y1={padding} x2={padding} y2={height - padding} stroke="#bbb" />
        {/* Price labels */}
        <text x={padding - 10} y={getY(minPrice)} textAnchor="end" fontSize={12} fill="#888">{minPrice}</text>
        <text x={padding - 10} y={getY(maxPrice)} textAnchor="end" fontSize={12} fill="#888">{maxPrice}</text>
        {/* Date labels */}
        {allDates.map((d, i) => (
          <text key={d} x={getX(i)} y={height - padding + 18} fontSize={10} textAnchor="middle" fill="#888">
            {d.slice(0, 10)}
          </text>
        ))}
        {/* Lines for each store */}
        {storeNames.map((store, sidx) => {
          const color = colors[sidx % colors.length];
          const points = stores[store].map(h => {
            const idx = allDates.indexOf(h.checked_at);
            return `${getX(idx)},${getY(h.store_price)}`;
          }).join(' ');
          return (
            <polyline
              key={store}
              fill="none"
              stroke={color}
              strokeWidth={2}
              points={points}
            />
          );
        })}
        {/* Dots for each price */}
        {storeNames.map((store, sidx) => {
          const color = colors[sidx % colors.length];
          return stores[store].map(h => {
            const idx = allDates.indexOf(h.checked_at);
            return (
              <circle
                key={store + h.checked_at}
                cx={getX(idx)}
                cy={getY(h.store_price)}
                r={3}
                fill={color}
                stroke="#fff"
                strokeWidth={1}
              />
            );
          });
        })}
      </svg>
      <div style={{ marginTop: 12, display: 'flex', gap: 16 }}>
        {storeNames.map((store, sidx) => (
          <span key={store} style={{ color: colors[sidx % colors.length], fontWeight: 600 }}>
            &#9632; {store}
          </span>
        ))}
      </div>
    </div>
  );
}

export default PriceHistoryChart;
